<app-page-layout [title]="'PASSWORD_RESET.RESET_PASSWORD'" [displayCustomerService]="false">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6 col-md-offset-3">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title class="center">{{'VALIDATION.VERIFY_TITLE' | translate}} {{loginID}}
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="row">
                            <ng-container *ngIf="isLoading(); else cardContent">
                                <app-loading></app-loading>
                            </ng-container>
                            <ng-template #cardContent>
                                <ng-container *ngIf="isInfoCard; else codeCard">
                                    <h4 class="text-center">{{'VALIDATION.VERIFY_METHOD' | translate}}</h4>
                                    <ng-container *ngTemplateOutlet="errorMessage"></ng-container>
                                    <form [formGroup]="form">
                                        <div class="col-md-12">
                                            <mat-radio-group class="body-container" formControlName="validationMethod">
                                                <mat-radio-button [value]="validationMethods.SMS">
                                                    <mat-icon aria-label="sms" class="icon-button">textsms</mat-icon>
                                                </mat-radio-button>
                                                <mat-radio-button [value]="validationMethods.CALL" class="margin5left">
                                                    <mat-icon aria-label="call" class="icon-button">phone_in_talk
                                                    </mat-icon>
                                                </mat-radio-button>
                                                <mat-radio-button [value]="validationMethods.EMAIL" class="margin5left">
                                                    <mat-icon aria-label="email" class="icon-button">email</mat-icon>
                                                </mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                        <mat-form-field class="col-md-12"
                                            *ngIf="form.get('validationMethod').value === validationMethods.EMAIL">
                                            <mat-label>{{'VALIDATION.EMAIL' | translate}}</mat-label>
                                            <input matInput name=" email" type="email" class="full-width"
                                                formControlName="email">
                                            <mat-error>
                                                {{'VALIDATION.REQUIRED'|translate}}
                                            </mat-error>
                                        </mat-form-field>
                                        <mat-form-field class="col-md-12"
                                            *ngIf="form.get('validationMethod').value !== validationMethods.EMAIL">
                                            <mat-label>{{'VALIDATION.PHONE_NUMBER' | translate}}</mat-label>
                                            <app-phone formControlName="phoneNumber" name="phoneNumber">
                                            </app-phone>
                                            <mat-error>
                                                {{'VALIDATION.REQUIRED'|translate}}
                                            </mat-error>
                                        </mat-form-field>
                                        <div class="col-md-12">
                                            <button mat-raised-button color="primary" class="full-width"
                                                [disabled]="isLoading()" (click)="submit()">
                                                {{'COMMON.CONFIRM' | translate}}
                                            </button>
                                        </div>

                                    </form>
                                </ng-container>
                                <ng-template #codeCard>
                                    <ng-container
                                        *ngIf="form.get('validationMethod').value === validationMethods.EMAIL; else validationCodeInput">
                                        <ng-container *ngTemplateOutlet="successMessage;context{redirect:false}">
                                        </ng-container>
                                    </ng-container>
                                    <ng-template #validationCodeInput>
                                        <ng-container *ngIf="isVerificationSuccess; else codeVerif">
                                            <ng-container *ngTemplateOutlet="successMessage;context{redirect:true}">
                                            </ng-container>
                                        </ng-container>
                                        <ng-template #codeVerif>
                                            <ng-container *ngTemplateOutlet="errorMessage"></ng-container>
                                            <form [formGroup]="codeForm">
                                                <mat-form-field class="col-md-12">
                                                    <mat-label>{{'VALIDATION.ENTER_CODE' | translate}}</mat-label>
                                                    <input matInput name="code" dividerColor="accent" class="full-width"
                                                        [placeholder]="'VALIDATION.ENTER_CODE' | translate"
                                                        formControlName="code" required>
                                                    <mat-error>
                                                        {{'VALIDATION.REQUIRED'|translate}}
                                                    </mat-error>
                                                </mat-form-field>
                                                <div class="col-md-12">
                                                    <button mat-raised-button color="primary" class="full-width"
                                                        (click)="verifyValue()">
                                                        {{'COMMON.CONFIRM' | translate}}
                                                    </button>
                                                </div>
                                            </form>
                                        </ng-template>
                                    </ng-template>
                                </ng-template>
                            </ng-template>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</app-page-layout>
<ng-template #errorMessage>
    <div class="col-md-12" *ngIf="errorMatcher.isError()">
        <div class="alert custom-danger text-left" role="alert">
            <p class="error">
                <mat-icon class="danger">error</mat-icon>
                <span *ngFor="let error of errorMatcher.logError">{{error.message | translate}}</span>
            </p>
        </div>
    </div>
</ng-template>
<ng-template #successMessage let-redirect="redirect">
    <div class="col-md-12">
        <div class="alert alert-success" role="alert">
            <span>{{ (redirect ?'EMAIL_CHECKER.ACCOUNT_ACTIVATED' :'VALIDATION.EMAIL_VALIDATION_DONE') |translate
                }}</span>
            <p> {{'COMMON.GO_TO_LOGIN' | translate }}</p>
        </div>
    </div>
</ng-template>